import React, { useState, useRef, useEffect, forwardRef } from 'react'
import ExtendedButton from './ExtendedButton'
import { Desktop, MEDIUM, Mobile } from '../util/breakpoints'
import useSiteData from '../../useSiteData'
import { getLocaleInfo } from '../../util/contentModelToData'
import useMediaQuery from '../util/useMediaQuery'

const LanguageSelected = ({ onClick, currentLocale, changeText = 'Change' }) => {
  const { name, flag } = getLocaleInfo(currentLocale)

  return (
    <div className="m-language-option m-language-option--selected">
        <span className="m-language-option__text">
            <img className="m-language-option__flag" src={ flag }/>
          { name }
        </span>
      <button className="m-language-option__btn a-btn a-btn--transparent" onClick={ onClick }>
        { changeText }
      </button>
    </div>
  )
}

const LanguagesList = forwardRef(({ locales, currentLocale }, ref) => {
    const [isOutOfBounds, setOutOfBounds] = useState(false)

    useEffect(() => {
      const dropdownElem = ref.current
      if (!dropdownElem) return

      const right = dropdownElem.getBoundingClientRect().right

      if (right > (window.innerWidth || document.documentElement.clientWidth)) {
        setOutOfBounds(true)
      }
    }, [])

    return (
      <ul
        className={ 'o-dropdown u-menu-indicator u-list-unstyled' + (isOutOfBounds ? ' u-menu-indicator--right' : '') }
        ref={ ref }
      >
        { locales.map(({ code, name, flag, link }) =>
          <a
            key={ code }
            className={ 'm-language-option' + (currentLocale === code ? ' m-language-option--active' : '') }
            href={ link }
          >
            <div className="m-language-option__text">
              <img alt={ 'Flag ' + code } className="m-language-option__flag" src={ flag }/>
              { name }
            </div>
          </a>
        ) }
      </ul>
    )
  }
)


export default ({ isDark, signInText, signInUrl }) => {
  const [isActive, setActive] = useState(false)
  const { locales: localeCodes, currentLocale } = useSiteData()
  const isDesktop = useMediaQuery({ minWidth: MEDIUM })
  const { translations } = useSiteData().pageSettings
  
  // If we are on mobile, filter out the current locale
  const locales = (isDesktop ? localeCodes : localeCodes.filter(code => code !== currentLocale)).map(getLocaleInfo)


  const languagesListElem = useRef(null)
  const desktopLanguageBtn = useRef(null)

  const handleClickOutside = event => {
    if (languagesListElem.current && !languagesListElem.current.contains(event.target) &&
      desktopLanguageBtn.current && !desktopLanguageBtn.current.contains(event.target)) {
      setActive(false)
    }
  }

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside)
    return () => document.removeEventListener('mousedown', handleClickOutside)
  }, [])

  return (
    <>
      { (signInText && signInUrl) &&
      <div className="m-nav-link">
        <ExtendedButton
          url={ signInUrl }
          className={ 'm-nav-link__action' + (isDark ? ' m-nav-link__action--dark' : '') }
          iconClassName="m-nav-link__icon a-icon a-icon--s"
          iconName="icon-user"
          text={ signInText }
          rel="nofollow"
        />
      </div>
      }
      <div className="m-nav-link">
        <Desktop>
          <ExtendedButton
            onClick={ () => setActive(!isActive) }
            className={ 'm-nav-link__action' + (isDark ? ' m-nav-link__action--dark' : '') }
            iconClassName="m-nav-link__icon a-icon a-icon--s"
            iconName="icon-globe"
            text={ (translations.selectLanguage ? translations.selectLanguage : 'Select language') }
            ref={ desktopLanguageBtn }
          />
        </Desktop>
        <Mobile>
          <LanguageSelected currentLocale={ currentLocale } onClick={ () => setActive(!isActive) }/>
        </Mobile>
        { isActive &&
        <LanguagesList ref={ languagesListElem } locales={ locales }
                       currentLocale={ currentLocale }/>
        }
      </div>
    </>
  )
}
